import axios from "axios";
import { databaseUrl } from "../../server/server";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
let access = localStorage.getItem("accesstoken");
const LogOut = () => {
  const navigate = useNavigate();
  useEffect(()=>{
    const go_logout = () => {
      axios.get(`${databaseUrl}/users/logout`,{
        headers: {Authorization:`Bearer ${access}`},
      }).then((response)=>{
        localStorage.removeItem('accesstoken');
        localStorage.removeItem('refreshtoken');
        localStorage.removeItem("happycallgrade");
        localStorage.removeItem("happycallname");
        navigate('/');
        window.location.reload();
      }).catch((error)=>{
        localStorage.removeItem('accesstoken');
        localStorage.removeItem('refreshtoken');
        localStorage.removeItem("happycallgrade");
        localStorage.removeItem("happycallname");
        navigate('/');
        window.location.reload();
    })
    }
  go_logout();
  },[])
  return (
      <div className="logout">
        LOG OUT
      </div>
  );
}
export default LogOut;